<div class="contact-dialog">
  <div class="contact-dialog-header">
    <mat-icon class="contact-dialog-icon">mail_outline</mat-icon>
    <h2 mat-dialog-title>Contact us</h2>
  </div>

  <mat-dialog-content class="contact-dialog-content">
    <p class="contact-dialog-intro">
      Email the LOQT team and we will come back to you.
    </p>

    <div class="contact-dialog-field">
      <span class="contact-dialog-label">Address</span>
      <span class="contact-dialog-value">{{ email }}</span>
    </div>

    <div class="contact-dialog-field">
      <span class="contact-dialog-label">Subject</span>
      <span class="contact-dialog-value">{{ subject$ | async }}</span>
    </div>

    <!-- Three ways out. The mail app needs a handler registered on this machine; the other two
         need only a browser, so one of them always works. -->
    <span class="contact-dialog-label contact-dialog-ways-label">Write to us with</span>
    <div class="contact-dialog-ways">
      <a
        mat-stroked-button
        class="contact-dialog-way"
        [href]="mailtoUrl$ | async"
        (click)="close()">
        <mat-icon>send</mat-icon>
        Your email app
      </a>
      <a
        mat-stroked-button
        class="contact-dialog-way"
        [href]="gmailUrl$ | async"
        target="_blank"
        rel="noopener"
        (click)="close()">
        <mat-icon>open_in_new</mat-icon>
        Gmail
      </a>
      <a
        mat-stroked-button
        class="contact-dialog-way"
        [href]="outlookUrl$ | async"
        target="_blank"
        rel="noopener"
        (click)="close()">
        <mat-icon>open_in_new</mat-icon>
        Outlook on the web
      </a>
    </div>

    <p class="contact-dialog-hint">
      Gmail and Outlook open in a new tab with the address and subject already filled in. Your email
      app only opens if this computer has one set up for it.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="contact-dialog-actions">
    <button mat-stroked-button type="button" (click)="copyEmail()">
      <mat-icon>content_copy</mat-icon>
      Copy address
    </button>
    <button mat-flat-button color="primary" type="button" (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
